import { Button } from "@mui/material"
import { useEffect, useState } from "react"
import { ASSET_ASSESSMENT_EVENTS, EVENTS } from "../../shared/constants/MIXAPANEL_EVENTS"
import { useAssessmentStore } from "../../shared/store"
import { trackMixpanelEvent } from "../../utils/helpers"
import Shell from "../shell"
import RenderAssetQuestion from "./render-assest-questions"

type JobPreferenceAssessmentProps = {
    handleSkip: () => void
    evaluateAssessment: (answers: any) => void
}
type Answers = {
    answer_id: string[]
    question_id: number
    question_type: string
}
const AssetAssessment = ({
    handleSkip,
    evaluateAssessment,
}: JobPreferenceAssessmentProps) => {
    const {
        answeredQuestions,
        assesmentQuestions,
        currentStep,
        screenDetails,
        setAnsweredQuestions,
        updateCurrentStep,
    } = useAssessmentStore((state) => state)

    const [selectedAnswers, setSelectedAnswers] = useState<Answers[]>([])
    const questionsArray = assesmentQuestions.questions[currentStep].questions
    const isVasFlow = assesmentQuestions?.mandatory
    const totalQuestions = assesmentQuestions?.questions.length
    const isLastStep = currentStep === totalQuestions - 1
    const numberOfQuestions = assesmentQuestions?.questions[currentStep]?.questions.length

    const tagIds: number[] = []
    const questionForMp: string[] = []
    assesmentQuestions?.questions[currentStep]?.questions.forEach((element) => {
        tagIds.push(element?.tags[0])
        questionForMp.push(element?.data?.title)
    })

    let totalSubQuestions = 0
    assesmentQuestions?.questions?.forEach((parentQuestion) => {
        totalSubQuestions += parentQuestion.questions.length
    })
    const saveEnabled =
        numberOfQuestions === selectedAnswers?.length ||
        totalSubQuestions === selectedAnswers?.length

    const commonMixpanel = {
        "No. of questions shown": numberOfQuestions,
        "Tag id of assets shown": tagIds,
        "Questions with ans": Array.from(selectedAnswers),
        "Page shown ": "Assests/Documents",
        "Application id": screenDetails.application_id,
    }
    const handleSkipClick = () => {
        trackMixpanelEvent("Post assessment skip button click", {
            ...commonMixpanel,
        })
        handleSkip()
    }

    /* 
    Separate handling for asset post call as multiple 
    question answered within a parent question
    was not the case previously
    */

    const handleOnCompletionAsset = (assetAns: any) => {
        if (!isLastStep) {
            updateCurrentStep()
            // to keep the global obj updated at each step
            assetAns?.forEach((obj: Answers) => {
                setAnsweredQuestions(obj.question_id, obj.question_type, obj.answer_id)
            })
        } else {
            const arrayAnswered = Array.from(answeredQuestions)
            // as updation is async we need to add the final answers
            assetAns?.forEach((obj: Answers) => {
                arrayAnswered.push(obj)
            })
            evaluateAssessment(arrayAnswered)
        }
    }
    const handleNextClick = async () => {
        trackMixpanelEvent(ASSET_ASSESSMENT_EVENTS.SAVE_CLICK, {
            ...commonMixpanel,
        })
        handleOnCompletionAsset(selectedAnswers)
    }
    const updateNewAnswers = (ansObject: Answers) => {
        const existingIndex = selectedAnswers.findIndex(
            (obj: Answers) => obj.question_id === ansObject.question_id
        )
        // to maintain unique question anwers only
        if (existingIndex !== -1) {
            const updatedObjects = [...selectedAnswers]
            updatedObjects[existingIndex] = ansObject
            setSelectedAnswers(updatedObjects)
        } else {
            setSelectedAnswers((prevArray: Answers[]) => [...prevArray, ansObject])
        }
    }

    useEffect(() => {
        trackMixpanelEvent(EVENTS.ENRICHMENT_SCREEN_SHOWN, {
            Type: isVasFlow ? "VAS" : "Application flow enrichment",
            "Entity Shown": "Asset Assessment",
            "Questions shown": questionForMp,
            "No. of questions shown": numberOfQuestions,
            "Tag id of assets shown": tagIds,
            "Application id": screenDetails.application_id,
        })
    }, [currentStep])

    // to reset the selected answers at each step, added in global array
    useEffect(() => {
        setSelectedAnswers([])
    }, [currentStep])

    return (
        <Shell
            footerElement={
                <div className="flex flex-col gap-4 items-center justify-center w-full">
                    {isVasFlow && (
                        <span className="text-onSurface-secondary text-xs text-center px-[35px] ">
                            Your Application would not be Successful if you do not
                            complete this step
                        </span>
                    )}

                    <div className="flex w-full flex-col items-center justify-center px-6 mb-10 bg-white">
                        <Button
                            fullWidth
                            onClick={handleNextClick}
                            style={{
                                padding: "16px",
                                borderRadius: "4px",
                                background: "#1F8268",
                                opacity: `${saveEnabled ? "1" : "0.5"}`,
                                color: "white",
                            }}
                            disabled={!saveEnabled}
                        >
                            <span>Save</span>
                        </Button>
                        {!isVasFlow && (
                            <Button onClick={handleSkipClick} variant="text">
                                Skip
                            </Button>
                        )}
                    </div>
                </div>
            }
        >
            <div className="flex flex-col">
                {assesmentQuestions.questions[currentStep].questions.map(
                    (question, index) => {
                        return (
                            <>
                                <RenderAssetQuestion
                                    question={question}
                                    index={index}
                                    questionsArray={questionsArray}
                                    updateNewAnswers={updateNewAnswers}
                                />
                            </>
                        )
                    }
                )}
            </div>
        </Shell>
    )
}
export default AssetAssessment
